'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withCustomAceContent = exports.AceContent = exports.Content = exports.withAceContent = exports.AceContentProvider = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _helpers = require('./helpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AceContext = _react2.default.createContext({});

var AceContentProvider = exports.AceContentProvider = function (_React$Component) {
  _inherits(AceContentProvider, _React$Component);

  function AceContentProvider() {
    _classCallCheck(this, AceContentProvider);

    return _possibleConstructorReturn(this, (AceContentProvider.__proto__ || Object.getPrototypeOf(AceContentProvider)).apply(this, arguments));
  }

  _createClass(AceContentProvider, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          props = _objectWithoutProperties(_props, ['children']);

      return _react2.default.createElement(
        AceContext.Provider,
        { value: props },
        children
      );
    }
  }]);

  return AceContentProvider;
}(_react2.default.Component);

AceContentProvider.propTypes = {
  content: _propTypes2.default.object.isRequired
};
AceContentProvider.defaultProps = {
  content: {}
};
var withAceContent = exports.withAceContent = function withAceContent(Component) {
  return function (props) {
    return _react2.default.createElement(AceContext.Consumer, {
      children: function children(ace) {
        return _react2.default.createElement(Component, _extends({}, props, {
          ace: ace
        }));
      }
    });
  };
};

var Content = exports.Content = withAceContent(function (props) {
  return _react2.default.createElement(AceContent, props);
});

Content.displayName = 'Content';

Content.propTypes = {
  fallback: _propTypes2.default.string.isRequired,
  name: _propTypes2.default.array.isRequired
};

var AceContent = exports.AceContent = function (_React$Component2) {
  _inherits(AceContent, _React$Component2);

  function AceContent() {
    var _ref;

    var _temp, _this2, _ret;

    _classCallCheck(this, AceContent);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this2 = _possibleConstructorReturn(this, (_ref = AceContent.__proto__ || Object.getPrototypeOf(AceContent)).call.apply(_ref, [this].concat(args))), _this2), _this2.state = {
      name: _this2.props.name,
      ace: _this2.props.ace,
      fallback: _this2.props.fallback,
      displayIds: false
    }, _temp), _possibleConstructorReturn(_this2, _ret);
  }

  _createClass(AceContent, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props2 = this.props,
          ace = _props2.ace,
          name = _props2.name,
          experiments = _props2.experiments;

      (0, _helpers.fireImpression)(ace, name, experiments);
      if ((0, _helpers.checkForContentDisplayParams)()) {
        this.setState({ displayIds: true });
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (prevProps.name !== this.props.name) {
        var _props3 = this.props,
            name = _props3.name,
            ace = _props3.ace,
            children = _props3.children,
            fallback = _props3.fallback,
            experiments = _props3.experiments;

        this.setState({ name: name, ace: ace, children: children, fallback: fallback });
        (0, _helpers.fireImpression)(ace, name, experiments);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props4 = this.props,
          _props4$ace = _props4.ace,
          ace = _props4$ace === undefined ? {} : _props4$ace,
          name = _props4.name,
          children = _props4.children,
          fallback = _props4.fallback;

      var content = (0, _helpers.getContent)(ace.content, name, fallback, this.state.displayIds) || children;

      if (content && content.value) {
        return content.value;
      }
      return content;
    }
  }], [{
    key: 'getDerivedStateFromProps',
    value: function getDerivedStateFromProps(nextProps, prevState) {
      if (nextProps.name !== prevState.name) {
        var name = nextProps.name,
            ace = nextProps.ace,
            children = nextProps.children,
            fallback = nextProps.fallback;

        return { name: name, ace: ace, children: children, fallback: fallback };
      }
      return null;
    }
  }]);

  return AceContent;
}(_react2.default.Component);

var hasExperimentData = function hasExperimentData(content, name, fallback) {
  return (0, _helpers.getContent)(content, name, fallback, (0, _helpers.checkForContentDisplayParams)()).makeImpressionCall;
};

var withCustomAceContent = exports.withCustomAceContent = function withCustomAceContent(Component) {
  var mapToProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return function (props) {
    return _react2.default.createElement(AceContext.Consumer, {
      children: function children(ace) {
        var aceProps = {};
        var experiments = [];
        for (var prop in mapToProps) {
          if (hasExperimentData(ace.content, mapToProps[prop]['name'], mapToProps[prop]['fallback'])) {
            experiments.push((0, _helpers.getContent)(ace.content, mapToProps[prop]['name'], mapToProps[prop]['fallback'], (0, _helpers.checkForContentDisplayParams)()).experimentName);

            aceProps[prop] = (0, _helpers.getContent)(ace.content, mapToProps[prop]['name'], mapToProps[prop]['fallback'], (0, _helpers.checkForContentDisplayParams)()).value;
          } else {
            aceProps[prop] = (0, _helpers.getContent)(ace.content, mapToProps[prop]['name'], mapToProps[prop]['fallback'], (0, _helpers.checkForContentDisplayParams)());
          }
        }

        var newProps = _extends({}, props, aceProps);
        return _react2.default.createElement(
          AceContent,
          _extends({}, newProps, { experiments: experiments }),
          _react2.default.createElement(Component, newProps)
        );
      }
    });
  };
};

withCustomAceContent.propTypes = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.array]).isRequired;